import { render, staticRenderFns } from "./ResetHist.vue?vue&type=template&id=446dd9be&scoped=true&"
import script from "./ResetHist.vue?vue&type=script&lang=js&"
export * from "./ResetHist.vue?vue&type=script&lang=js&"
import style0 from "./ResetHist.vue?vue&type=style&index=0&id=446dd9be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446dd9be",
  null
  
)

export default component.exports